import { __ } from '@wordpress/i18n';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { boxShadow, VayuBlocksCssTextAlign, borderRadiusStyle, VayuBlocksTypography, dimensions,
    background, borderStyle} from "@vayu-blocks/global";

const handleValue = (val) => {

    if (typeof val === 'string') {
        
      if (/^\d+px$/.test(val)) {
          return val;
      }
       if (val.startsWith('var:preset|')) {
        const parts = val.split('|');
        if (parts.length === 3) {
          const presetType = parts[1]; // e.g., 'padding'
          const presetKey = parts[2];  // e.g., '30'
          // Format the value dynamically as per your requirement
          return `var(--wp--${presetType}-${presetKey})`;
        }
      }
  
    }
  
    return val;
};

const gridContainerStyles = (attributes) => {
    const view = VayuBlocksDevice();
    
    const column = attributes.column?.[view] ?? 3;
    const row = attributes.row?.[view] ?? 2;

    return {
        display: 'grid',
        gridTemplateColumns: `repeat(${column}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${row}, minmax(100px, 1fr))`,
        rowGap: handleValue(attributes.vergap?.[view]?.top),
        columnGap: handleValue(attributes.horigap?.[view]?.left),
        gridAutoRows: 'minmax(100px, auto)'
    };
};

const getWidthStyle = (attributes, view) => {
    switch (view) {
        case 'Desktop':
            return {
                width: attributes.layoutcustomWidth,
            };
        case 'Tablet':
            return {
                width: attributes.layoutcustomWidthTablet ,
            };
        case 'Mobile':
            return {
                width: attributes.layoutcustomWidthMobile,
            };
        default:
            return {};
    }
};

const postStyles = (attributes) => {
    const view = VayuBlocksDevice();
    const widthstyle = getWidthStyle(attributes,view);
    return {
        width: `${attributes.width === 'customwidth' ? attributes.customWidthlayout : attributes.width}`,
        padding: dimensions(attributes.layoutpadding, view),
        ...background(attributes.layoutbackground),
        ...borderStyle(attributes.layoutborder,view),
        ...borderRadiusStyle(attributes.layoutradius,view),
        ...boxShadow(attributes.layoutShadow, view),
        ...widthstyle,
        position: 'relative',
        backgroundAttachment: attributes.layout_backgroundAttachment,
        backgroundRepeat: attributes.layout_backgroundRepeat,
        backgroundSize: attributes.layout_backgroundSize,
        display:'flex',
        flexDirection:'column',
        alignItems: attributes.pg_layoutalignment?.[view] === 'left' 
            ? 'start' : attributes.pg_layoutalignment?.[view] === 'center'
            ? 'center': attributes.pg_layoutalignment?.[view] === 'right'
            ? 'end' : '',
        gap:attributes.spacing?.[view],
    };
};

const featuredImageStyles = (attributes) => {
    const view = VayuBlocksDevice();

    return {
        display: 'block',
        width: '100%',
        height: 'auto',
        ...borderStyle(attributes.imageborder,view),
        ...borderRadiusStyle(attributes.imageradius,view),
    };
};

const categoryButtonStyles = (attributes) => {
	const view = VayuBlocksDevice(); 

    return {
        ...borderStyle(attributes.categoryborder,view),
        ...borderRadiusStyle(attributes.categoryradius,view),
        ...boxShadow(attributes.categoryShadow, view),
        ...VayuBlocksTypography(attributes.categorytypography, view),
        padding: dimensions(attributes.categorypadding, view),
        color: `${attributes.pg_categoryTextColor}`,
        background: attributes.category_backgroundColor,
    };
};

//Title
const titleTagStyles = (attributes) => {
    const view = VayuBlocksDevice();

    const styles = {
        ...VayuBlocksTypography(attributes.titletypography, view),
        margin:0,
        display:'flex',
    };

    // Conditionally add styles based on titlechoice
    if (attributes.titlechoice === 'color') {
        styles.color = attributes.pg_TitleColor;
    } else if (attributes.titlechoice === 'gradient') {
        styles.background = `${attributes.pg_TitleColor} text` ;
        styles.WebkitTextFillColor = 'transparent';
        styles.WebkitBackgroundClip = 'text';
        styles.backgroundClip = 'text';
    }

    return styles;
};

const titleTagStylesatag = (attributes) => {
    const styles = {
        textDecoration: 'none',
    };

    // Conditionally add styles based on titlechoice
    if (attributes.titlechoice === 'color') {
        styles.color = attributes.pg_TitleColor;
    } else if (attributes.titlechoice === 'gradient') {
        styles.background = `${attributes.pg_TitleColor} text` ;
        styles.WebkitTextFillColor = 'transparent';
        styles.WebkitBackgroundClip = 'text';
        styles.backgroundClip = 'text';
    }

    return styles;
};

const authorAndDateContainerStyles = (attributes) => {
    const view = VayuBlocksDevice();
    return {
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        ...VayuBlocksTypography(attributes.authortypography, view),
        color: `${attributes.pg_authorTextColor}`, 
        fill: `${attributes.pg_authorTextColor}`, 
    };
};

const dateSectionStyles = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap', 
};

const authorLinkStyles = (attributes) => {
    return {
        textDecoration: 'none',
        marginRight: '10px',
        color: `${attributes.pg_authorTextColor}`, 
    };
};

const showOnlyDateStyles = (attributes) => {
    return {
        color: `${attributes.pg_authorTextColor}`, 
    }; 
};

//Tag
const tagButtonStyles = (attributes ) => {
    const view = VayuBlocksDevice();

    return {
        color: `${attributes.pg_tagTextColor}`,
        background: attributes.tag_backgroundColor,
        boxSizing: 'border-box', 
        ...borderStyle(attributes.tagborder,view),
        ...borderRadiusStyle(attributes.tagradius,view),
        ...boxShadow(attributes.tagShadow, view),
        ...VayuBlocksTypography(attributes.tagtypography, view),
        padding: dimensions(attributes.tagpadding, view),
     
    };
};

// Content Style
const fullContentStyle = (attributes) => {
    const view = VayuBlocksDevice();

    return {
        color: `${attributes.pg_textColor}`,
        ...VayuBlocksCssTextAlign(attributes.pg_layoutalignment,view),
        ...VayuBlocksTypography(attributes.contenttypography, view),
    };
};

const PaginationStyles = (attributes) => {
    const view = VayuBlocksDevice();
    
    return {
        padding: dimensions(attributes.pg_Paginationpadding, view),
        ...VayuBlocksTypography(attributes.typography, view),
        ...borderStyle(attributes.pg_paginationborder,view),
        ...borderRadiusStyle(attributes.pg_paginationradius,view),
        cursor:'pointer',
        color: `${attributes.pg_PaginationColor} !important`,
        background: attributes.pg_PaginationbackgroundColor,
        margin: '20px 5px',
    };
};

const excerptstyles = (attributes) => {
    const view = VayuBlocksDevice();

    return {
        ...VayuBlocksTypography(attributes.excetypography, view),
        color: attributes.exceColor,
    }
}

const paginationnewstyle = (attributes) => {
    const view = VayuBlocksDevice();

    return {
        ...VayuBlocksCssTextAlign(attributes.pg_Paginationalignment, view)
    };
};

const categoryContainerStyles = (attributes) => {
    const view = VayuBlocksDevice();

    return {
        display: 'flex',
        flexWrap: 'wrap',
        gap:attributes.categoryGap?.[view],
    }
}

const tagContainerStyles = (attributes) => {
    const view = VayuBlocksDevice();

    return {
        display: 'flex',
        flexWrap: 'wrap',
        gap:attributes.tagGap?.[view],
    }
}

export {
    PaginationStyles,
    gridContainerStyles,
    postStyles,
    fullContentStyle,
    showOnlyDateStyles,
    authorAndDateContainerStyles,
    dateSectionStyles,
    tagButtonStyles,
    titleTagStyles,
    categoryButtonStyles,
    featuredImageStyles,
    authorLinkStyles,
    titleTagStylesatag,
    paginationnewstyle,
    categoryContainerStyles,
    tagContainerStyles,
    excerptstyles,
};